__turbopack_context__.v({
  "highlightLabel": "OrganizerVerticalEventCard-module-scss-module__eW1xCG__highlightLabel",
  "priceWrapper": "OrganizerVerticalEventCard-module-scss-module__eW1xCG__priceWrapper",
  "promotedLabel": "OrganizerVerticalEventCard-module-scss-module__eW1xCG__promotedLabel",
  "scale-in-left": "OrganizerVerticalEventCard-module-scss-module__eW1xCG__scale-in-left",
  "urgencySignals": "OrganizerVerticalEventCard-module-scss-module__eW1xCG__urgencySignals",
});
